import ProfileForm from './ProfileForm';
export default ProfileForm;



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileForm/index.js